export default {
    tagsView: {
        refresh: '刷新',
        closeOthers: '关闭其他',
        closeAll: '关闭所有',
        close: '关闭',
        allTags: '所有标签页'
    },
    route: {
        index: 'Index',
        BillDetails: 'Bill Details',
        SetttleDetails: 'Bill Details',
        settle: 'Settle',
        bill: 'Bill',
        deposit: 'Deposit',
        DepositDetails: 'Deposit Details',
        cost: 'Cost check',
        distribution: 'Distribution',
        warehouse: 'Warehouse',
        loadAndUnload: 'LoadAndUnload',
        deliver: 'Deliver',
        install: 'Install',
        networkDistribution: 'Network Distribution',
        manualEstimate: 'ManualEstimate',
        fine: 'Fine',
        fineDetails: 'Fine Details'
    }
};